var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfoLight = function SvgInfoLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    stroke: "#191818"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191818",
    fillRule: "evenodd",
    d: "M10.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM8 10h2v4H8v1h5v-1h-2V9H8v1Z",
    clipRule: "evenodd"
  })));
};
export { SvgInfoLight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTAuNSIgY3k9IjEwLjUiIHI9IjEwIiBzdHJva2U9IiMxOTE4MTgiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC41IDdDMTEuMDUyMyA3IDExLjUgNi41NTIyOCAxMS41IDZDMTEuNSA1LjQ0NzcyIDExLjA1MjMgNSAxMC41IDVDOS45NDc3MiA1IDkuNSA1LjQ0NzcyIDkuNSA2QzkuNSA2LjU1MjI4IDkuOTQ3NzIgNyAxMC41IDdaTTggMTBIMTBWMTRIOFYxNUgxMEgxMUgxM1YxNEgxMVYxMFY5SDEwSDhWMTBaIiBmaWxsPSIjMTkxODE4Ii8+Cjwvc3ZnPgo=";